import { FAVORITES_CONTRACT } from '@/api/contracts/favorites';
import type {
  FavoriteIdsResponse,
  FavoriteMutationResponse,
  RawFavoriteListItem,
  RawFavoriteListResponse,
} from '@/api/contracts/favorites';
import { resolvePathTemplate } from '@/api/contracts';
import type { ItemListItem } from '@/types';
import { normalizeItemListItem } from './items';
import { api } from './client';

export interface FavoritesListResponse {
  items: ItemListItem[];
  itemIds: number[];
  count: number;
}

function normalizeFavoriteListItem(item: RawFavoriteListItem): ItemListItem {
  return normalizeItemListItem(item);
}

export async function listFavorites(): Promise<FavoritesListResponse> {
  const response = await api<RawFavoriteListResponse>(FAVORITES_CONTRACT.list.path, {
    method: FAVORITES_CONTRACT.list.method,
    responseSchema: FAVORITES_CONTRACT.list.schemas.response,
  });

  return {
    items: response.items.map(normalizeFavoriteListItem),
    itemIds: response.itemIds,
    count: response.count,
  };
}

export function listFavoriteIds(): Promise<FavoriteIdsResponse> {
  return api<FavoriteIdsResponse>(FAVORITES_CONTRACT.ids.path, {
    method: FAVORITES_CONTRACT.ids.method,
    responseSchema: FAVORITES_CONTRACT.ids.schemas.response,
  });
}

export function addFavorite(itemId: number): Promise<FavoriteMutationResponse> {
  return api<FavoriteMutationResponse>(FAVORITES_CONTRACT.add.path, {
    method: FAVORITES_CONTRACT.add.method,
    body: { itemId },
    requestSchema: FAVORITES_CONTRACT.add.schemas.request,
    responseSchema: FAVORITES_CONTRACT.add.schemas.response,
  });
}

export function removeFavorite(itemId: number): Promise<FavoriteMutationResponse> {
  return api<FavoriteMutationResponse>(
    resolvePathTemplate(FAVORITES_CONTRACT.remove.path, { itemId }),
    {
      method: FAVORITES_CONTRACT.remove.method,
      responseSchema: FAVORITES_CONTRACT.remove.schemas.response,
    },
  );
}
